import { useState, useRef, useEffect, useId } from "react";
import { ChevronDown } from "lucide-react";
import { portalUrl } from "../data";

export default function LoginDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const menuId = useId();

  // Fecha o menu ao clicar fora ou com Esc
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    const handleKey = (event) => event.key === "Escape" && setIsOpen(false);
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKey);
    };
  }, []);

  return (
    <div className="portal" ref={dropdownRef}>
      <button
        type="button"
        className="portal-btn"
        aria-expanded={isOpen}
        aria-controls={menuId}
        onClick={() => setIsOpen(!isOpen)}
      >
        Portal do cliente
        <ChevronDown size={16} />
      </button>

      <div id={menuId} className="portal-menu" data-open={isOpen}>
        <a href={portalUrl}>
          FIDC
          <span>Acesso de cedentes do FinTrust FIDC</span>
        </a>
        <a href={portalUrl}>
          Securitizadora
          <span>Acesso de clientes da securitizadora</span>
        </a>
      </div>
    </div>
  );
}
